export const jjhWorks = {
  album: [
    {
      id: 1,
      title: '가슴에 지는 태양',
      year: '2022.05.09.',
      image: require('./album/1. 가슴에 지는 태양.jpg'),
      link: 'https://www.melon.com/album/detail.htm?albumId=10946738'
    },
    {
      id: 2,
      title: '웃자',
      year: '2021.08.29.',
      image: require('./album/2. 웃자.jpg'),
      link: 'https://www.melon.com/album/detail.htm?albumId=10691950'
    },
    {
      id: 3,
      title: '잊어주라',
      year: '2020.09.22.',
      image: require('./album/3. 잊어주라.jpg'),
      link: 'https://www.melon.com/album/detail.htm?albumId=10493832'
    },
    {
      id: 4,
      title: '둘만의 이야기',
      year: '2020.03.13.',
      image: require('./album/5. 둘만의 이야기.png'),
      link: 'https://www.melon.com/album/detail.htm?albumId=10402556'
    },
    {
      id: 5,
      title: '낯선 계절이와',
      year: '2019.07.25.',
      image: require('./album/4. 낯선 계절이와.jpg'),
      link: 'https://www.melon.com/album/detail.htm?albumId=10310416'
    },
    {
      id: 6,
      title: '이별 후폭풍',
      year: '2019.04.13.',
      image: require('./album/6. 이별 후폭풍.jpg'),
      link: 'https://www.melon.com/album/detail.htm?albumId=10273556'
    },
    {
      id: 7,
      title: 'OST_ 동네변호사 조들호2 죄와 벌 PART.6',
      year: '2019.02.25.',
      image: require('./album/OST_ 동네변호사 조들호2 죄와 벌 PART.6.png'),
      link: 'https://www.melon.com/album/detail.htm?albumId=10254283'
    },
    {
      id: 8,
      title: '010-',
      year: '2018.11.27.',
      image: require('./album/7. 010-.jpg'),
      link: 'https://www.melon.com/album/detail.htm?albumId=10226312'
    },
    {
      id: 9,
      title: '생각나길',
      year: '2018.07.09.',
      image: require('./album/8. 생각나길.jpg'),
      link: 'https://www.melon.com/album/detail.htm?albumId=10182801'
    },
    {
      id: 10,
      title: '약속',
      year: '2018.03.06.',
      image: require('./album/9 약속.jpg'),
      link: 'https://www.melon.com/album/detail.htm?albumId=10144701'
    },
    {
      id: 11,
      title: 'Feel Feel',
      year: '2017.10.19.',
      image: require('./album/10. Feel Feel.jpg'),
      link: 'https://www.melon.com/album/detail.htm?albumId=10102363'
    },
    {
      id: 12,
      title: 'Up Down',
      year: '2017.05.04.',
      image: require('./album/11. Up Down.jpg'),
      link: 'https://www.melon.com/song/detail.htm?songId=30396319'
    },
    {
      id: 13,
      title: 'I See U',
      year: '2017.02.21.',
      image: require('./album/12. I See U.jpg'),
      link: 'https://www.melon.com/album/detail.htm?albumId=10039751'
    },
  ]
}